import React, { useState } from 'react';
import RealisationsHero from '../components/realisations/RealisationsHero/RealisationsHero';
import pb from '../lib/pocketbase';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faFilePdf, faUser, faEnvelope, faPhone, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import styles from './Contact.module.css'; // Reusing some contact styles for consistency
import pageStyles from './NotreCooperative.module.css'; // Reusing some page layout styles
import localStyles from './Recrutement.module.css'; // For specific styles

function RecrutementPage() {
    const [formData, setFormData] = useState({
        name: pb.authStore.model?.name || '',
        email: pb.authStore.model?.email || '',
        phone: pb.authStore.model?.phone || '',
        position: '',
        message: '',
    });
    const [cvFile, setCvFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const currentUser = pb.authStore.model;

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setCvFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!pb.authStore.isValid) {
            toast.error("Veuillez vous connecter pour postuler.");
            return;
        }
        if (!cvFile && !currentUser?.cv) {
            toast.error("Veuillez joindre votre CV.");
            return;
        }

        setIsSubmitting(true);
        try {
            const data = new FormData();
            data.append('name', formData.name);
            data.append('phone', formData.phone);
            data.append('position', formData.position);
            data.append('application_message', formData.message);
            data.append('application_status', 'NOUVEAU');
            data.append('profile_type', 'candidate');
            data.append('emailVisibility', 'true');

            if (cvFile) {
                data.append('cv', cvFile);
            }

            await pb.collection('users').update(currentUser.id, data);

            toast.success("Votre candidature a bien été enregistrée dans votre profil ! Nous reviendrons vers vous prochainement.");
            setFormData(prev => ({ ...prev, message: '' }));
            setCvFile(null);
            if (document.getElementById('cv-upload')) {
                document.getElementById('cv-upload').value = '';
            }
        } catch (error) {
            console.error("Error submitting application:", error);
            toast.error("Une erreur est survenue lors de la mise à jour de votre profil.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={pageStyles.pageWrapper}>
            <RealisationsHero
                title="Rejoignez l'Aventure"
                subtitle="Construisons ensemble l'habitat de demain au sein de notre coopérative artisanale."
                backgroundImage="/images/ossaturebois1.jpg"
            />

            <section className={localStyles.recrutementSection}>
                <div className={localStyles.container}>
                    <div className={localStyles.introSection}>
                        <span className={localStyles.eyebrow}>Carrières</span>
                        <h2 className={localStyles.title}>Vivez l'expérience Maison Quinard</h2>
                        <div className={localStyles.divider}></div>
                        <p className={localStyles.mainSubtitle}>
                            Maison Quinard n'est pas une entreprise ordinaire. Nous sommes une coopérative d'artisans passionnés par la construction bois et l'écologie.
                        </p>
                    </div>

                    <div className={localStyles.benefitsGrid}>
                        <div className={localStyles.benefitCard}>
                            <div className={localStyles.benefitIcon}>🌲</div>
                            <h4>Éthique & Écologie</h4>
                            <p>Travaillez avec des matériaux nobles, locaux et durables pour un impact positif sur la planète.</p>
                        </div>
                        <div className={localStyles.benefitCard}>
                            <div className={localStyles.benefitIcon}>🤝</div>
                            <h4>Esprit Coopératif</h4>
                            <p>Ici, chaque voix compte. Nous valorisons l'humain, l'entraide et la réussite collective.</p>
                        </div>
                        <div className={localStyles.benefitCard}>
                            <div className={localStyles.benefitIcon}>🛠️</div>
                            <h4>Savoir-faire</h4>
                            <p>Apprenez et partagez des techniques de pointe en ossature bois avec des maîtres artisans.</p>
                        </div>
                        <div className={localStyles.benefitCard}>
                            <div className={localStyles.benefitIcon}>🚀</div>
                            <h4>Projets Uniques</h4>
                            <p>Participez à des chantiers sur-mesure, innovants et architecturalement ambitieux.</p>
                        </div>
                    </div>

                    <div className={localStyles.formWrapper}>
                        <div className={localStyles.formDecoration}>
                            <h3>Rejoignez-nous</h3>
                            <p>Nous sommes toujours à la recherche de charpentiers, menuisiers et conducteurs de travaux partageant nos valeurs.</p>
                            <div className={localStyles.infoPoints}>
                                <span><FontAwesomeIcon icon={faPhone} /> 04 76 XX XX XX</span>
                                <span><FontAwesomeIcon icon={faEnvelope} /> contact@maisonquinard.fr</span>
                            </div>
                        </div>

                        {!pb.authStore.isValid ? (
                            <div className={localStyles.formCard} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '40px' }}>
                                <div className={localStyles.benefitIcon} style={{ fontSize: '3rem', marginBottom: '20px' }}>🔐</div>
                                <h3>Connexion Requise</h3>
                                <p style={{ marginBottom: '30px', color: '#64748b' }}>
                                    Pour postuler chez Maison Quinard, vous devez posséder un compte utilisateur.
                                    Cela nous permet de gérer votre dossier de manière sécurisée.
                                </p>
                                <div style={{ display: 'flex', gap: '15px' }}>
                                    <button
                                        className={localStyles.submitBtn}
                                        onClick={() => window.location.href = '/login?redirect=/recrutement'}
                                        style={{ width: 'auto', padding: '12px 30px' }}
                                    >
                                        Se connecter
                                    </button>
                                    <button
                                        className={localStyles.submitBtn}
                                        onClick={() => window.location.href = '/login?mode=signup&redirect=/recrutement'}
                                        style={{ width: 'auto', padding: '12px 30px', backgroundColor: 'var(--color-primary-dark)' }}
                                    >
                                        Créer un compte
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className={localStyles.formCard}>
                                <div className={localStyles.formHeader}>
                                    <h3>Dossier de candidature</h3>
                                    <p>Complétez votre profil pour nous envoyer votre candidature.</p>
                                </div>
                                <form onSubmit={handleSubmit} className={localStyles.applyForm}>
                                    <div className={localStyles.inputGroup}>
                                        <label htmlFor="name">Nom Complet</label>
                                        <div className={localStyles.inputField}>
                                            <FontAwesomeIcon icon={faUser} />
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                placeholder="Jean Dupont"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className={localStyles.inputGroup}>
                                        <label htmlFor="phone">Téléphone</label>
                                        <div className={localStyles.inputField}>
                                            <FontAwesomeIcon icon={faPhone} />
                                            <input
                                                type="tel"
                                                id="phone"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleInputChange}
                                                placeholder="06 12 34 56 78"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className={localStyles.inputGroup}>
                                        <label htmlFor="email">Email</label>
                                        <div className={localStyles.inputField}>
                                            <FontAwesomeIcon icon={faEnvelope} />
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                placeholder="jean@exemple.com"
                                                disabled
                                                style={{ opacity: 0.7, cursor: 'not-allowed' }}
                                            />
                                        </div>
                                    </div>

                                    <div className={localStyles.inputGroup}>
                                        <label htmlFor="position">Poste souhaité</label>
                                        <div className={localStyles.inputField}>
                                            <FontAwesomeIcon icon={faBriefcase} />
                                            <input
                                                type="text"
                                                id="position"
                                                name="position"
                                                value={formData.position}
                                                onChange={handleInputChange}
                                                placeholder="Charpentier, Menuisier..."
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className={localStyles.inputGroup}>
                                        <label htmlFor="cv-upload">Votre CV (PDF, DOC) {currentUser?.cv && <span style={{ color: '#10b981' }}>(Déjà fourni)</span>}</label>
                                        <div className={localStyles.fileInputContainer}>
                                            <input
                                                type="file"
                                                id="cv-upload"
                                                onChange={handleFileChange}
                                                accept=".pdf,.doc,.docx"
                                                className={localStyles.fileInput}
                                                required={!currentUser?.cv}
                                            />
                                            <div className={localStyles.filePlaceholder}>
                                                <FontAwesomeIcon icon={faFilePdf} />
                                                <span>{cvFile ? cvFile.name : (currentUser?.cv ? "Changer votre CV" : "Cliquez pour choisir un fichier")}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={localStyles.inputGroup}>
                                        <label htmlFor="message">Votre message de motivation</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleInputChange}
                                            rows="4"
                                            placeholder="Dites-nous ce qui vous motive à nous rejoindre..."
                                            required
                                        />
                                    </div>

                                    <button type="submit" className={localStyles.submitBtn} disabled={isSubmitting}>
                                        {isSubmitting ? (
                                            <>Envoi en cours...</>
                                        ) : (
                                            <>
                                                {currentUser?.application_status !== 'AUCUN' ? 'Mettre à jour ma candidature' : 'Envoyer ma candidature'}
                                                <FontAwesomeIcon icon={faPaperPlane} />
                                            </>
                                        )}
                                    </button>
                                </form>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );

}

export default RecrutementPage;
